import { UntypedFormGroup } from "@angular/forms";
import { QuestionBase } from "../models/forms/question-base";

export function resetInputsForm(form: UntypedFormGroup, inputs: QuestionBase<unknown>[], keyInputs: string[], setKeyEmptyArrayFormValue?: string[], clearKeyInputsOptions?: string[]): void {
  const formObj = {};
  keyInputs.forEach(key => {
    const keyInput = inputs.find(input => input.key === key);
    if (keyInput) {
      keyInput.value = keyInput.dataSource ? [] : null;
      keyInput.selectedIds = [];
      if (clearKeyInputsOptions?.length && clearKeyInputsOptions.includes(key)) { keyInput.options = []; }
      formObj[key] = setKeyEmptyArrayFormValue?.length && setKeyEmptyArrayFormValue.includes(key) ? [] : null;
    }
  });
  form.patchValue(formObj, {emitEvent: true});
}

export function mapFormParamValueToIds<T>(paramValue: { id: T }[] | undefined | null): T[] | null {
  return paramValue?.length ? paramValue.map(item => item.id) : null;
}
